export default __webpack_public_path__ + "static/anastasiia-chichik-1d2ed00b425d2e19a9a1356f706ae14b.png";